import { render, staticRenderFns } from "./motherday.vue?vue&type=template&id=35fc7418&scoped=true&"
import script from "./motherday.vue?vue&type=script&lang=js&"
export * from "./motherday.vue?vue&type=script&lang=js&"
import style0 from "./motherday.vue?vue&type=style&index=0&id=35fc7418&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fc7418",
  null
  
)

export default component.exports